export enum AttributeEntityType {
  Person = 'Person',
  Team = 'Team',
  Survey = 'Survey',
  Seat = 'Seat',
  Evaluation = 'Evaluation',
}
